/**
 * HHT1 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT1_EP5_ANSWERS = [
    'Harry, Holly, Stephanie, and Matt are in the car. They are driving to Grandma’s.',
    'On the way, Harry wants ice cream. The family decides to stop by for some ice cream.',
    'At the stand, the family looks through the menu.',
    'The ice cream looks so wonderful! They all dream of ice cream castles and dancing ice cream cones!',
    'But Matt just can’t decide what flavor to choose. There’re so many flavors!',
    'Finally, he chooses lemon cheesecake. But he changes his mind. He is not sure what he likes.',
    'Meanwhile, Harry gets bubble gum ice cream, Holly gets chocolate peanut butter, and Stephanie chooses lemon cheesecake.',
    'Finally, Matt decides to get the lemon cheesecake flavor.',
    'But the clerk says they ran out! Stephanie had the last scoops!',
    'The family is at Grandma’s house. They just finished eating dinner.',
    'Grandma asks if anyone wants dessert. Matt says he’s too full.',
    'Grandma says that it’s lemon cheesecake, and suddenly Matt doesn’t feel full!',
    'Grandma gives some to Holly, Harry, and Stephanie but none to Matt! Stephanie had the last piece!',
];

// export const HHT1_EP5_ANSWER_SOUNDS = [
//     '/1_EP05_SB_TL_01.mp3',
//     '/1_EP05_SB_TL_02.mp3',
//     '/1_EP05_SB_TL_03.mp3',
//     '/1_EP05_SB_TL_04.mp3',
//     '/1_EP05_SB_TL_05.mp3',
//     '/1_EP05_SB_TL_06.mp3',
//     '/1_EP05_SB_TL_07.mp3',
//     '/1_EP05_SB_TL_08.mp3',
//     '/1_EP05_SB_TL_09.mp3',
//     '/1_EP05_SB_TL_10.mp3',
//     '/1_EP05_SB_TL_11.mp3',
//     '/1_EP05_SB_TL_12.mp3',
//     '/1_EP05_SB_TL_13.mp3',
// ];

export const HHT1_EP5_ANSWER_SOUNDS = [
    '/811e7ac9f4ecf59dbfd71fdd07af720f.mp3',
    '/39221f3f9113f250202ade7ebd0a1ea7.mp3',
    '/b861820d698881fcac86a5a986c2c6b7.mp3',
    '/b9fa67abf991215da65a24630007ebe6.mp3',
    '/ceb51738dab0822c6a17ba31addea905.mp3',
    '/de1f5fd35b5b71789398cc82e70c53b9.mp3',
    '/4ca5fd5d86e7e18104370e3a623596fc.mp3',
    '/ab41ab2a7e449a1fb8afd117263109e0.mp3',
    '/00fbfdac9dd9259625e4e41a9122e155.mp3',
    '/ca80e883f5712a1a02f1064789e9e392.mp3',
    '/c747ac86fd4b96d677908547bf45a852.mp3',
    '/6ba34a3289a78f482f57261d1a6ee987.mp3',
    '/f9119e152a3408f42cd12bac162d826e.mp3',

];

export const HHT1_EP5_QUIZ_ITEMS = [{
    'A': HHT1_EP5_ANSWERS[1],
    'B': HHT1_EP5_ANSWERS[12],
    'SoundIndexA': 1,
    'SoundIndexB': 12,
    'answer': HHT1_EP5_ANSWERS[1],
    'sound': [2],
    'exception': false,
},
    {
        'A': HHT1_EP5_ANSWERS[3],
        'B': HHT1_EP5_ANSWERS[9],
        'SoundIndexA': 3,
        'SoundIndexB': 9,
        'answer': HHT1_EP5_ANSWERS[3],
        'sound': [4],
        'exception': false,
    },
    {
        'A': HHT1_EP5_ANSWERS[0],
        'B': HHT1_EP5_ANSWERS[5],
        'SoundIndexA': 0,
        'SoundIndexB': 5,
        'answer': HHT1_EP5_ANSWERS[5],
        'sound': [6, 7],
        'exception': false,
    },
    {
        'A': HHT1_EP5_ANSWERS[2],
        'B': HHT1_EP5_ANSWERS[8],
        'SoundIndexA': 2,
        'SoundIndexB': 8,
        'answer': HHT1_EP5_ANSWERS[8],
        'sound': [9, 10],
        'exception': true,
    },
    {
        'A': HHT1_EP5_ANSWERS[11],
        'B': HHT1_EP5_ANSWERS[7],
        'SoundIndexA': 11,
        'SoundIndexB': 7,
        'answer': HHT1_EP5_ANSWERS[11],
        'sound': [12],
        'exception': false,
    },

]
